<div class="content-heading">
  <div class="header-container">
    <h3>Configuración Vehicular</h3>
    <small>Catálogo de configuración vehicular para transporte</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">

      <div class="row">
        <div class="ml-auto mr-3 align-self-end">
          <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"></aph-custom-buttons>
        </div>
        <div class="col-12">
          <app-ceq-table #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
            (apiEmitter)="gridEmiter($event)">
          </app-ceq-table>
        </div>
      </div>

      <div class="row mt-4 align-items-center">
        <div class="col-md-12 d-flex align-items-center">
          <div class="pagesize-control">
            <span class="mr-2">Registros por página:</span>
            <select class="form-control d-inline-block w-auto" (change)="onPageSizeChange($event.target.value)"
              [(ngModel)]="pageSize">
              <option *ngFor="let size of PageSizes" [value]="size">{{size}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-12 mt-2">
          <aph-custom-buttons preset="add" label="Nueva configuración vehicular" (btnClick)="btnAddClick()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>